import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {GlobalService} from "../../services/global.service";
import {HttpCommonService} from "../../services/http-common.service";
import {LoginService} from "../../services/login.service";
import {Router} from "@angular/router";
import {User} from '../../models/user';
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {Title} from "@angular/platform-browser";
import {environment} from "../../../environments/environment";

declare var $: any;

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit, AfterViewInit, OnDestroy {
  memberCenterUrl: string;
  // 企业名片弹出框
  isVisible = false;
  // 企业建档弹出框
  isVisible2 = false;
  userType: any;
  userId: any;
  user: User;
  index = 0;
  autoTimer: any;//全局变量目的实现左右点击同步
  clickEndFlag = true; //设置每张走完才能再点击
  liHeight = 0;
  checkOverOut = false;

  //新闻列表
  newsList: any;
  //最新认证列表
  rzList: any;
  mark: any = 0;
  timer: any = null;

  // 显示未读消息个数
  messageCount = 0;

  constructor(public globalService: GlobalService, public http: HttpCommonService,
              public login: LoginService,
              private router: Router, private msg: NzMessageService,
              private titleService: Title, private showNzModal: NzModalService,) {
    this.user = new User();
    this.user.id = this.globalService.getUserInfo("_userId");
    this.userType = this.globalService.getUserInfo('_userType');
    this.globalService.isIndex = true;
  }

  ngOnInit() {
    this.titleService.setTitle('新华信用平台');
    this.getNews();
    // this.ready();
    this.getUserLoginStatus();
    // 获取最新入驻的接口需要有token,所以延迟加载1s
    setTimeout(() => this.getRZList(), 1000);
  }

  ngAfterViewInit() {
    /*$(function() {
      $('#scrollDivA').slimScrollA({
        height: 'auto'
      });
      $('#scrollDivB').slimScrollB({
        height: 'auto'
      });
    });*/
    this.start();
  }

  /**
   * 退出登陆
   */
  loginOut() {
    this.login.loginOut();
    this.messageCount = 0;
  }

  ngOnDestroy() {
    this.globalService.isIndex = false;
    this.checkOverOut = true;
    clearInterval(this.timer);
  }


  // 企业名片显示弹框
  showModal() {
    // 判断是否是第一次新建名片
    this.isVisible = true;
  }

  // 企业建档显示弹框
  showModal2() {
    this.isVisible2 = true;
  }

  // 企业名片隐藏弹框
  handleCancel = () => {
    this.isVisible = false;
  }

  // 企业建档隐藏弹框
  handleCancel2 = () => {
    this.isVisible2 = false;
  }

  // 个人用户点击企业建档、名片按钮，弹窗点击“申请入驻”时跳转
  prohibitCancel(){
    $(document).on('click', '.ant-btn.ant-btn-ghost', function(){
      // alert(99);
      window.location.href="registerEnterp?type=1";
    });
  }


  //点击创建企业名片弹出协议
  check(e) {
    /*if (this.userType == 'enterprise') {
      this.mbcenterEnterpInfoService.getEnterInfo(this.user.id).subscribe(data => {
        if (data.data.cardType == '1') {
          this.isVisible = false;
          // this.isButtonShow = true;
          // this.router.navigateByUrl("BusinessCardParent/EnterpDevelopment");
          // window.open(window.location.href + 'BusinessCardParent/EnterpDevelopment');
        } else {
          // 新用户首次登录弹出协议
          // this.isVisible = true;
        }
      });
    } else {
      e.preventDefault();
      // this.msg.error("请登录企业账号");
      let thiss = this;
      this.showNzModal.warning({
        content: '该功能仅对企业入驻用户开放，您可以登录企业账号使用；若您尚无企业账号，可先申请企业入驻',
        okText: '登录企业账号',
        onOk: () => {
          // 自动退出并调整到企业用户
          this.http.get("/auth/jwt/logout").subscribe(data => {
            //thiss.cookieService.delete("auth-token");
            thiss.globalService.checkLoginState();
            thiss.globalService.deleteLocalStorage();
            thiss.globalService.isLoginedUser = false;
          });
          thiss.router.navigate(['comLR/login'], {queryParams: {'selectIndex': '1'} });
        },
        cancelText: '申请入驻',
        onCancel: () => {
        },
      });
      this.prohibitCancel();
    }*/
  }

  //企业名片确认阅读协议
  checkProtocol() {
    /*this.isVisible = false;
    // this.router.navigateByUrl("BusinessCardParent/EnterpDevelopment");
    this.user['cardType'] = '1';
    this.mbcenterEnterpInfoService.updateEnterpInfo2(this.user).subscribe(data => {
    });*/
  }


  //点击创建企业档案弹出协议
  check1(e) {
    /*if (this.userType == 'enterprise') {
      this.mbcenterEnterpInfoService.getEnterInfo(this.user.id).subscribe(data => {
        if (data.data.recordType == '1') {
          this.isVisible2 = false;

          // this.router.navigateByUrl("EstablishArchivesParent/FilingBasicInfo");
          // window.open(window.location.href + 'EstablishArchivesParent/FilingBasicInfo');
        } else {
          // 新用户首次登录弹出协议
          //this.isVisible2 = true;
        }
      });
    } else {
      e.preventDefault();
      // this.msg.error("请登录企业账号");
      let thiss = this;
      this.showNzModal.warning({
        content: '该功能仅对企业入驻用户开放，您可以登录企业账号使用；若您尚无企业账号，可先申请企业入驻',
        okText: '登录企业账号',
        onOk: () => {
          // 自动退出并调整到企业用户
          this.http.get("/auth/jwt/logout").subscribe(data => {
            //thiss.cookieService.delete("auth-token");
            thiss.globalService.checkLoginState();
            thiss.globalService.deleteLocalStorage();
            thiss.globalService.isLoginedUser = false;
          });
          thiss.router.navigate(['comLR/login'], {queryParams: {'selectIndex': '1'} });
        },
        cancelText: '申请入驻',
        onCancel: () => {
        },
        showConfirmLoading: true
      });
      this.prohibitCancel();
    }*/
  }

  //企业建档确认阅读协议
  checkProtocol2() {
    /*this.isVisible2 = false;
    // this.router.navigateByUrl("EstablishArchivesParent/FilingBasicInfo");
    this.user['recordType'] = '1';
    this.mbcenterEnterpInfoService.updateEnterpInfo3(this.user).subscribe(data => {
    });*/
  }

  helpCentern() {
    this.router.navigateByUrl("helpCenter/platformIntroduction");
  }

  getTouristToken() {
    this.http.get("/auth/jwt/generateTouristToken").subscribe(result => {
    });
  }

  // 用户登陆之后获取初始化消息数量
  getMessageInitCount () {
    let url = '';
    if (this.globalService.getUserInfo('_userType') == "person") {//个人
      url = "/user/center/myMessage/findPCount";
    } else {//企业
      url = "/user/center/myMessage/findCCount";
    }
    this.http.get(url).subscribe(result => {
      this.messageCount = result.data.notRead;
    });
  }

  createWebSocket(userId: string, userType: string) {
    const thisContext = this;
    let websocket = null;
    // 判断当前浏览器是否支持WebSocket
    if ('WebSocket' in window) {
      websocket = new WebSocket(environment.webSocketApi + '?userId=' + userId + '&userType=' + userType);
    } else {
      return;
    }

    // 连接发生错误的回调方法
    websocket.onerror = function () {
    };

    // 连接成功建立的回调方法
    websocket.onopen = function () {
      // 3分钟发送一次心跳
            setInterval(function(){
              websocket.send("HeartBeat");
            }, 180000);
    };

    // 接收到消息的回调方法
    websocket.onmessage = function (event) {
      thisContext.messageCount = event.data;
    };

    // 连接关闭的回调方法
    websocket.onclose = function () {
    };

    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
    window.onbeforeunload = function () {
      closeWebSocket();
    };

    // 关闭WebSocket连接
    function closeWebSocket() {
      websocket.close();
    }
  }

  /**
   * 判断用户是否已登录
   */
  getUserLoginStatus() {
    this.http.get("/auth/jwt/isLogin").subscribe(result => {
      // 已登录
      if (result.stateCode == '20111') {

        this.globalService.setLoginState(true);
        this.userType = result.data.userType;
        let userInfo = {};
        if (result.data.userType) {
          userInfo['_userType'] = result.data.userType;
          if (result.data.userType == 'enterprise') {
            this.memberCenterUrl = '/MemberCenterParent/EnterpInfoParent/MbcenterEnterpInfo';
          } else if (result.data.userType == 'person') {
            this.memberCenterUrl = '/MemberCenterParent/PersonInfoParent/MyInfo';
          } else {
            if (this.globalService.isFirstAccess == '0') {
              this.getTouristToken();
            }
          }
        } else {
          if (this.globalService.isFirstAccess == '0') {
            this.getTouristToken();
          }
        }

        if (result.data.userName) {
          userInfo['_userName'] = result.data.userName;
        }

        if (result.data.userId) {
          userInfo['_userId'] = result.data.userId;
        }

        // 获取初始化消息数量
        this.getMessageInitCount();
        try {
          // 创建webSocket连接
          this.createWebSocket(result.data.userId, result.data.userType);
        } catch (e) {
          // console.info(e);
        }

        if (result.data.roles != null && result.data.roles.length > 0) {
          userInfo['_role'] = result.data.roles[0].roleName;
        }

        if (result.data.companyId) {
          userInfo['_companyId'] = result.data.companyId;
        }

        if (result.data.companyName) {
          userInfo['_companyName'] = result.data.companyName;
        }

        if (result.data.pType) {
          userInfo['_pType'] = result.data.pType;
        }

        this.globalService.setUserInfo(JSON.stringify(userInfo));
      } else {
        this.globalService.deleteLocalStorage();
        if (this.globalService.isFirstAccess == '0') {
          this.getTouristToken();
        }
      }

      this.globalService.isFirstAccess = '1';
      this.globalService.checkLoginState();
    });

    if (this.globalService.isFirstAccess == '0') {
      this.getTouristToken();
    }
    this.globalService.isFirstAccess = '1';
  }


  //首页-新闻列表
  getNews() {
    let thiss = this;
    this.http.get("/user/center/xhsRest/getNewsList",
      {url: '/xhxy_Json/xytt/index.json'}).subscribe(result => {
      if (result.stateCode == "1") {
        this.newsList = result.data.list;
        setTimeout(() => thiss.rotaion(), 100);
        // $(".yx-rotaion").yx_rotaion({auto:true});
      }
    });
  }

  //more跳转到列表页
  toList(type: string) {
    this.router.navigate(['/newsList'], {queryParams: {type: type}});
  }

  //详情页
  toDetail(url: string) {
    this.router.navigate(['/newsDetail'], {queryParams: {url: url}});
  }

  //首页-最新认证
  getRZList() {
    let thiss = this;
    this.http.get("/user/center/xhsRest/certifi/getNewCertification").subscribe(result => {
      if (result.stateCode == "1") {
        this.rzList = result.data;
        // if (result.data.length > 1) {
        //   setTimeout(() => thiss.ready(),100);
        // }
      }
    });
  }

  //新闻滚动
  rotaion() {
    $(".yx-rotaion").yx_rotaion({auto: true});
    //限制字符个数
    $(".overEll").each(function () {
      var maxwidth = 54;
      if ($(this).text().length > maxwidth) {
        $(this).text($(this).text().substring(0, maxwidth));
        $(this).html($(this).html() + '…');
      }
    });
    $(".overTitle").each(function () {
      var maxwidth = 40;
      if ($(this).text().length > maxwidth) {
        $(this).text($(this).text().substring(0, maxwidth - 2));
        $(this).html($(this).html() + '…');
      }
    });
  }

  ready() {

    //跑马灯
    /*$('.dowebok').liMarquee({
      circular: false
    });*/

    //底部最新认证的滚动
    $(".font_inner li:eq(0)").clone(true).appendTo($(".font_inner")); //克隆第一个放到最后(实现无缝滚动)
    this.liHeight = $(".swiper_wrap").height() / 2;
    //一个li的高度
    //获取li的总高度再减去一个li的高度(再减一个Li是因为克隆了多出了一个Li的高度)
    let totalHeight = ($(".font_inner li").length * $(".font_inner li").eq(0).height()) - this.liHeight;
    $(".font_inner").height(totalHeight); //给ul赋值高度

    let thiss = this;
    //切换到下一张
    $(".swiper_wrap .gt").on("click", function () {
      if (thiss.clickEndFlag) {
        thiss.next(thiss);
        thiss.clickEndFlag = false;
      }
    });

    //切换到上一张
    $(".swiper_wrap .lt").on("click", function () {
      if (thiss.clickEndFlag) {
        thiss.prev(thiss);
        thiss.clickEndFlag = false;
      }
    });
    //开启自动轮播
    thiss.autoTimer = setInterval(function () {
      if (thiss.checkOverOut) {
        clearInterval(thiss.autoTimer);
        return;
      }
      thiss.next(thiss);
    }, 3000);

    //自动轮播
    /*$(".font_inner a").hover(function() {
      clearInterval(thiss.autoTimer);
    }, function() {
      clearInterval(thiss.autoTimer);
      thiss.autoTimer = setInterval(()=>thiss.next(thiss),3000);
    });*/

    //鼠标放到左右方向时关闭定时器
    /*$(".swiper_wrap .lt,.swiper_wrap .gt").hover(function() {
      clearInterval(thiss.autoTimer);
    }, function() {
      thiss.autoTimer = setInterval(()=>thiss.next(thiss),3000);
    });*/
  }

  start() {
    var tabs = $(".indPublishBox dl");
    this.timer = null;
    this.mark = 0;
    let thiss = this;

    //自动轮播函数
    function play() {
      if (thiss.checkOverOut) {
        clearInterval(thiss.timer);
        return;
      }
      thiss.mark++;
      if (thiss.mark == tabs.length) {
        thiss.mark = 0;
      }
      thiss.changeTab(thiss.mark);
    }

    //添加事件，轮播开始
    this.timer = setInterval(play, 3000);
    /*tabs.addEventListener('mouseover',function(){
    if (thiss.timer) {
      clearInterval(thiss.timer);
    }
    this.thiss=null;
  },false);*/
    /* tabs.addEventListener('mouseout',function(){
       if (thiss.timer) {
         clearInterval(thiss.timer);
       }
         thiss.timer=setInterval(play,2000);
     },false);*/
    /*for(var i=0;i<tabs.length;i++){
      tabs[i].index=i;
      tabs[i].addEventListener('mouseover',function(){
        change(this.index);
      },false);
    }*/
  }

  //改变状态
  changeTab(index) {
    var tabs = $(".indPublishBox dl");
    for (var j = 0; j < tabs.length; j++) {
      tabs[j].className = '';
    }
    tabs[index].className = "timeLight";
    var ddTabs = $(".indPublishBox dl dd");
    for (var j = 0; j < ddTabs.length; j++) {
      ddTabs[j].style.background = "rgba(25, 65, 122, 0.9)";
    }
    ddTabs[index].style.background = "#1494e2";
    var controls = $(".iVscrollCon1");
    for (var k = 0; k < controls.length; k++) {
      controls[k].style.display = 'none';
    }
    controls[index].style.display = "block";

    this.mark = index;
  }

  //鼠标移入事件
  over(i) {
    if (i < 10) {
      this.changeTab(i);
    }
    this.checkOverOut = true;
    var tabs = $(".indPublishBox dl");
    tabs[this.mark].className = '';
    var ddTabs = $(".indPublishBox dl dd");
    ddTabs[this.mark].style.background = "#fff";
    var imgTabs = $(".indPublishBox dl dd img");
    imgTabs[this.mark * 2].style.display = "none";
    imgTabs[this.mark * 2].style.opacity = 0;
    imgTabs[this.mark * 2 + 1].style.display = "block";
    imgTabs[this.mark * 2 + 1].style.opacity = 1;
  }

  //鼠标移出事件
  out(i) {
    if (i < 10) {
      this.changeTab(i);
    }
    this.checkOverOut = false;
    var tabs = $(".indPublishBox dl");
    tabs[this.mark].className = 'timeLight';
    var ddTabs = $(".indPublishBox dl dd");
    ddTabs[this.mark].style.background = "rgba(25, 65, 122, 0.9)";
    var imgTabs = $(".indPublishBox dl dd img");
    imgTabs[this.mark * 2].style.display = "block";
    imgTabs[this.mark * 2].style.opacity = 1;
    imgTabs[this.mark * 2 + 1].style.display = "none";
    imgTabs[this.mark * 2 + 1].style.opacity = 0;

  }

  tabChange() {
    let thiss = this;
    $(".font_inner").stop().animate({
      top: -thiss.index * thiss.liHeight
    }, 400, function () {
      thiss.clickEndFlag = true; //图片走完才会true
      if (thiss.index == $(".font_inner li").length - 1) {
        $(".font_inner").css({
          top: 0
        });
        thiss.index = 0;
      }
    });
  }

  next(thiss) {
    thiss.index++;
    if (thiss.index > $(".font_inner li").length - 1) { //判断index为最后一个Li时index为0
      thiss.index = 0;
    }
    thiss.tabChange();
  }

  prev(thiss) {
    thiss.index--;
    if (thiss.index < 0) {
      thiss.index = $(".font_inner li").size() - 2; //因为index的0 == 第一个Li，减二是因为一开始就克隆了一个LI在尾部也就是多出了一个Li，减二也就是_index = Li的长度减二
      $(".font_inner").css("top", -($(".font_inner li").size() - 1) * thiss.liHeight); //当_index为-1时执行这条，也就是走到li的最后一个
    }
    thiss.tabChange();
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/index/index.component.ts